__turbopack_context__.v({
  "buttonsContainer": "myf75G_buttonsContainer",
  "canRotate": "myf75G_canRotate",
  "centerContainer": "myf75G_centerContainer",
  "fade-in": "myf75G_fade-in",
  "flipperButton": "myf75G_flipperButton",
  "rotated": "myf75G_rotated",
});
